import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useDispatch } from 'react-redux';
import qs from 'qs';
import client from '../../../lib/api/client'; // 프로젝트의 client 인스턴스 경로

const CompanySelect = ({ siteType, onSiteChange }) => {
  const dispatch = useDispatch();

  const handleCompanySwitch = async (event) => {
    const newCompany = event.target.value; // 'hcinfo' 또는 'mega'
    
    // 1. 세션 스토리지에서 Formik이 저장해둔 이메일 주소 확보
    const userEmail = sessionStorage.getItem('email');
    
    if (!userEmail) {
      alert("로그인 세션 정보가 없습니다. 다시 로그인해 주세요.");
      return;
    }

    try {
      // 2. 백엔드에 이메일과 변경할 회사 정보를 전송하여 새 토큰 요청
      const response = await client.post('/api/v1/user/switch-company', { 
        username: userEmail,   // LoginDto 필드 스펙 일치 (세션스토리지에서 꺼낸 이메일 주소)
        password: '',          // 사용하지 않으므로 공백 처리
        company: newCompany,   // 새로 바꿀 회사 코드 ('hcinfo' 또는 'mega')
        loginType: ''
      });
      
      if (response.data.success) {
        const newToken = response.data.data; // 새 JWT 토큰
        
        // 3. [프로젝트 스펙 일치] 로컬 스토리지 키 이름 동기화 및 client 헤더 갱신
        localStorage.setItem('access_token', JSON.stringify(newToken));
        client.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        
        // 4. [핵심 추가] 새로고침 이후에도 부모 컴포넌트가 값을 기억할 수 있도록 저장
        localStorage.setItem('current_company', newCompany);

        // 5. [user API 스펙 반영] 헤더에 토큰과 companyCd를 실어 유저 정보 재요청
        const userRes = await client.get('/api/v1/user/info', {
          headers: {
            Authorization: `Bearer ${newToken}`,
            companyCd: `${newCompany}`,
          },
        });

        // 6. [getBaseCode API 스펙 반영] 토큰 문자열을 쿼리스트링화하여 공통코드 호출
        const queryString = qs.stringify(newToken); 
        const baseRes = await client.get(`/api/v1/common/list?${queryString}`);

        // 7. [getNoties API 스펙 반영] 파라미터 없이 깔끔하게 알림 리스트 재호출
        const notieRes = await client.get(`/api/v1/noti/list`);

        // 8. 로컬 스토리지의 기존 'user' 객체를 완벽히 새로 받아온 데이터로 덮어쓰기
        localStorage.setItem('user', JSON.stringify(userRes.data));

        // 9. 리덕스 스토어(Redux Store) 상태 동기화 (새로고침 없이 실시간 리렌더링 대비)
        dispatch({
          type: 'auth/LOGIN_SUCCESS', // ◀ 문자열로 안전하게 주입 완료
          payload: {
            access_token: newToken,
            baseCodes: baseRes.data.list,
            user: userRes.data,
            noties: notieRes.data.list,
            notiCount: notieRes.data.count,
          },
        });

        // 10. 부모 컴포넌트(DrawerTemplate)의 상단바 UI용 상태 값 동기화
        if (onSiteChange) {
          onSiteChange(event);
        }
        
        // 11. [새로고침] 모든 데이터 동기화 완료 후 브라우저 안전하게 리로드
        window.location.reload();
        
        alert(`${newCompany.toUpperCase()} 환경으로 전환되었습니다.`);
      }
    } catch (error) {
      console.error("스키마 전환 오류:", error);
      alert(error.response?.data?.message || "회사 전환에 실패했습니다.");
    }
  };

  return (
    <FormControl size="small" sx={{ ml: 1, minWidth: 110 }}>
      <Select
        value={siteType}
        onChange={handleCompanySwitch}
        sx={{
          height: '32px',
          fontSize: '13px',
          fontWeight: 'bold',
          backgroundColor: '#ffffff',
        }}
      >
        <MenuItem value="hcinfo">HCINFO</MenuItem>
        <MenuItem value="mega">MEGA</MenuItem>
      </Select>
    </FormControl>
  );
};

export default CompanySelect;
